// extracted by mini-css-extract-plugin
module.exports = {"SplashScreen":"Splash_SplashScreen__2xiwg","Hide":"Splash_Hide__19PtS","Delete":"Splash_Delete__25JQv","GMall":"Splash_GMall__2EzBK","Show":"Splash_Show__3BY-d"};